import { useNavigate } from "react-router-dom";
import Button from "../../../Helpers/Button/Button";
import trans, { isRTL } from "../../../../utils";
import { useState } from "react";

export default function OfflineFormFooter({
	loading,
	addConfig,
	submitAttempt,
	step,
	disable,
	mutlipage,
	next,
	back,
	steps,
	formReqVal,
	route,
}) {
	const navigate = useNavigate();
	console.log("Step", step);
	const [nextvalid, setNextValid] = useState(true);
	return (
		<>
			<div
				style={{
					backgroundColor: "white",
					borderTop: "1px solid #EBECF0",
					boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
					padding: "6px",
					marginTop: "auto",
				}}
			>
				{!mutlipage ? (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							flexDirection: "row-reverse",
						}}
					>
						<Button
							type={"primary"}
							htmlType="submit"
							text={trans("Save")}
							disabled={loading}
							style={{ marginLeft: !isRTL && "8px" }}
						/>
						<Button
							type="default"
							htmlType="button"
							text={trans("Close")}
							onClick={() => navigate(`/${route}`)}
							disabled={loading}
							style={{ marginLeft: isRTL && "8px" }}
						/>
					</div>
				) : (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						{step === 0 ? (
							<Button
								type="default"
								htmlType="button"
								text={trans("Close")}
								onClick={() => navigate(`/${route}`)}
								disabled={loading}
								style={{ marginLeft: isRTL && "8px" }}
							/>
						) : (
							<Button
								type={"default"}
								htmlType="button"
								text={trans("Back")}
								disabled={loading}
								onClick={back}
							/>
						)}
						{step !== 0 ? (
							<Button
								type={"primary"}
								htmlType="submit"
								text={trans("Save")}
								disabled={loading}
							/>
						) : (
							<Button
								type={"primary"}
								htmlType="button"
								text={trans("Next")}
								disabled={loading}
								onClick={async (e) => {
									if (e) e.preventDefault();
									setNextValid(true);
									await next(e);
								}}
							/>
						)}
					</div>
				)}
				{step !== Number(steps?.length - 1)
					? nextvalid
					: submitAttempt &&
						(!addConfig.isValid || formReqVal) && (
							<div
								className={`validation ${isRTL ? "text-start" : "text-end"}`}
							>
								{trans("Please Check Required Inputs")}
							</div>
						)}
			</div>
		</>
	);
}
